<template>
  <header class="header">
    <div class="inner">
      <div class="logo-wrapper">
        <div class="logo"></div>
        <div class="line"></div>
        <h2 class="title">{{$vi18n('$i18n# 创作者服务中心 #i18n$')}}</h2>
      </div>
      <div class="info-wrapper">
        <el-select v-model="lang" class="lang-selector" @change="langChangeHandler">
          <el-option v-for="e in langList" :key="e.value" :label="e.label" :value="e.value"></el-option>
        </el-select>
        <el-popover placement="bottom" width="160" v-model="visible">
          <p>{{$vi18n('$i18n# 您确定要退出吗 #i18n$')}}？</p>
          <div class="avatar-wrapper">
            <el-button size="mini" type="text" @click="visible = false">
              {{$vi18n('$i18n# 取消 #i18n$')}}
            </el-button>
            <el-button type="primary" size="mini" @click="handleSubmitLogout">
              {{$vi18n('$i18n# 确定 #i18n$')}}
            </el-button
            >
          </div>
          <img v-show="avatar" :src="avatar" alt="" class="avatar" slot="reference" />
        </el-popover>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import store from '@/store/index.js'
export default {
  data() {
    return {
      visible: false,
      lang: localStorage.getItem('current_lang') || sessionStorage.getItem('url_lang') || localStorage.getItem('country_lang') || 'en',
      langList: [
        {
          label: "简体中文",
          value: 'cn'
        },
        {
          label: "English",
          value: 'en'
        },
        {
          label: "繁體中文",
          value: 'tw'
        },
        {
          label: "ภาษาไทย",
          value: 'tha'
        },
        {
          label: "Español",
          value: 'esn'
        },
        {
          label: "Português",
          value: 'ptb'
        },
        {
          label: "日本語",
          value: 'jpn'
        },
        {
          label: "Tiếng Việt",
          value: 'vie'
        },
        {
          label: "Malay",
          value: 'msa'
        }
      ],
      avatar: ''
    };
  },
 
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.getAvatar()
  },
  methods: {
    ...mapMutations(['CLEAR_ALL_INFO', 'RESET_ROUTER']),
    handleSubmitLogout() {
      this.CLEAR_ALL_INFO();
      this.RESET_ROUTER();
      // localStorage.clear()

      localStorage.setItem('current_lang', document.documentElement.getAttribute('lang'))
      sessionStorage.clear()
      this.$router.push({ path: '/login' });
    },
    langChangeHandler() {
      localStorage.setItem('current_lang', this.lang)
      window.location.reload()
    },
    getAvatar() {
      const img = new Image()
      img.src = this.userInfo.avatar
      img.onload = () => {
        this.avatar = this.userInfo.avatar
      }
      img.onerror = () => {
        const defaultAvatar = 'https://image.mini1.cn/roleicon/2.png'
        this.avatar = defaultAvatar
        store.state.userInfo.avatar = defaultAvatar
      }
    }
  },
};
</script>

<style lang="scss">
.avatar-wrapper {
  padding-top: 10px;
  text-align: right;
}
</style>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  .inner {
    display: flex;
    height: 64px;
    justify-content: space-between;
    align-items: center;
    width: 1280px;
    margin: 0 auto;
  }

  .logo-wrapper {
    display: flex;
    align-items: center;

    .logo {
      width: 60px;
      height: 38px;
      background: url(~@/assets/images/icon_logo.png) no-repeat;
      background-size: 100%;
    }
    .line {
      width: 1px;
      height: 20px;
      margin: 0 23px;
      background: #d9d9d9;
    }
    .title {
      font-size: 16px;
      line-height: 24px;
      color: #497db1;
    }
  }

  .info-wrapper {
    display: flex;
    .avatar {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
    }
  }
}
.lang-selector {
  margin-right: 20px;
}
</style>
